export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  author: string;
  date: string;
  views: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { name: "网红塌房", slug: "wanghong-tafang", icon: "ri-user-unfollow-line", count: 128 },
  { name: "明星爆料", slug: "mingxing-baoliao", icon: "ri-star-line", count: 96 },
  { name: "直播翻车", slug: "zhibo-fanche", icon: "ri-live-line", count: 73 },
  { name: "娱乐圈内幕", slug: "yulequan-neimu", icon: "ri-movie-line", count: 85 },
  { name: "综艺八卦", slug: "zongyi-bagua", icon: "ri-tv-line", count: 54 },
  { name: "电竞吃瓜", slug: "dianjing-chigua", icon: "ri-gamepad-line", count: 42 },
];

export const articles: Article[] = [
  {
    id: 1,
    slug: "dingzhen-chuxian-haidilao-beizhi-jiehuo",
    title: "丁真现身海底捞被指「接活」，粉丝爬墙速度刷新吉尼斯纪录",
    excerpt: "近日，有网友在成都某海底捞偶遇丁真，爆料称其正在为某品牌做探店推广。然而评论区画风突变，粉丝集体脱粉回踩，场面一度失控。知情人士透露，丁真团队目前正在紧急公关，试图挽回形象。",
    content: `<p>近日，有网友在成都某海底捞偶遇丁真，爆料称其正在为某品牌做探店推广。然而评论区画风突变，粉丝集体脱粉回踩，场面一度失控。</p>
<p>据现场目击者描述，丁真当天身穿黑色休闲装，头戴棒球帽，试图低调出行。但因其独特的气质和随行团队规模庞大，很快便被认出。有食客拍下视频上传至社交平台后，短短两小时内播放量突破500万。</p>
<p>然而，评论区的走向却出乎所有人意料。大量粉丝表示"心碎"，认为丁真"变了"，不再是当初那个"纯真的理塘少年"。更有甚者翻出丁真近半年的商业活动记录，整理成"塌房时间线"广为流传。</p>
<p>一位不愿透露姓名的娱乐圈从业者向本平台爆料："丁真团队这两年商业变现太急了，粉丝的容忍度已经到了极限。这次海底捞事件只是一个导火索。"</p>
<p>截至发稿前，丁真工作室尚未就此事做出正式回应。但据知情人士透露，团队正在紧急商议公关策略，不排除近期会发布道歉声明。</p>
<p>本平台将持续关注事态发展，为大家带来第一手爆料。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    imageUrl: "https://readdy.ai/api/search-image?query=Young%20Tibetan%20influencer%20in%20dark%20casual%20outfit%20at%20hotpot%20restaurant%2C%20dramatic%20moody%20lighting%2C%20cinematic%20photography%20style%2C%20dark%20background%20with%20warm%20accents%2C%20editorial%20composition%2C%20high%20contrast%20shadows%2C%20mysterious%20atmosphere%2C%20night%20scene%2C%20grainy%20texture&width=800&height=600&seq=article-01&orientation=landscape",
    author: "吃瓜前线记者",
    date: "2026-07-07",
    views: 1283000,
    comments: 5921,
    tags: ["丁真", "海底捞", "塌房", "脱粉", "网红翻车"],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    slug: "li-jiaqi-zhibojian-jiage-xuni",
    title: "李佳琦直播间被曝价格虚标，同行晒进货单打脸，网友直呼又被割韭菜了",
    excerpt: "知名带货主播李佳琦直播间近日陷入价格造假风波。有同行主播公开晒出同款商品进货单，显示李佳琦直播间所谓的「全网最低价」实际高出进货价近三倍，引发网友热议。",
    content: `<p>知名带货主播李佳琦直播间近日陷入价格造假风波。有同行主播公开晒出同款商品进货单，显示李佳琦直播间所谓的「全网最低价」实际高出进货价近三倍。</p>
<p>事情的起因是某美妆品牌的新品发布会。李佳琦在直播间宣称该品牌全线产品"全网最低价"，并强调"只有我这里才有这个价格"。然而，另一位小有名气的美妆博主在社交平台晒出了该品牌的官方进货单，清晰显示进货价仅为李佳琦直播间售价的三分之一。</p>
<p>此消息一出，舆论哗然。大量消费者在评论区表达愤怒："又被割韭菜了""原来最低价是这么来的""退货去了兄弟们"。</p>
<p>业内人士分析认为，直播带货行业的价格乱象由来已久。部分头部主播凭借流量优势，与品牌方签订排他协议，人为制造"最低价"假象，实际上是在割消费者的韭菜。</p>
<p>目前，李佳琦团队尚未就此事做出回应。但该品牌官方客服已开始私下联系投诉消费者，试图息事宁人。</p>
<p>本平台提醒广大消费者，购物时务必货比三家，不要轻信直播间的"最低价"宣传。</p>`,
    category: "直播翻车",
    categorySlug: "zhibo-fanche",
    imageUrl: "https://readdy.ai/api/search-image?query=Live%20streaming%20influencer%20in%20dramatic%20studio%20lighting%20with%20products%20on%20desk%2C%20cinematic%20moody%20atmosphere%2C%20dark%20background%20with%20spotlight%2C%20editorial%20photography%2C%20high%20contrast%2C%20suspenseful%20vibe%2C%20professional%20setup%2C%20night%20aesthetic&width=800&height=600&seq=article-02&orientation=landscape",
    author: "黑料挖掘机",
    date: "2026-07-06",
    views: 985000,
    comments: 4312,
    tags: ["李佳琦", "直播带货", "价格造假", "割韭菜", "消费者权益"],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    slug: "wang-yibo-siliao-baoguang",
    title: "王一博私聊记录遭曝光，内容劲爆引发粉丝大战，工作室紧急发声明",
    excerpt: "一组疑似王一博与某女星的私密聊天记录在社交平台疯传。聊天内容涉及敏感话题，迅速引发双方粉丝大规模互撕。王一博工作室已紧急发布声明，称将追究造谣者法律责任。",
    content: `<p>一组疑似王一博与某女星的私密聊天记录在社交平台疯传。聊天内容涉及敏感话题，迅速引发双方粉丝大规模互撕。</p>
<p>据悉，这组聊天记录最早出现在某匿名爆料平台，随后被多个营销号转发。记录中显示的对话内容尺度较大，涉及个人隐私和敏感话题。虽然真实性尚未得到证实，但已经在粉丝群体中引起了轩然大波。</p>
<p>王一博的粉丝迅速组织"反黑"行动，质疑聊天记录的真实性，指出多处P图痕迹。而另一方的粉丝则借机发起攻击，双方在各大社交平台展开了激烈的骂战，相关话题阅读量已突破10亿。</p>
<p>法律界人士表示，无论聊天记录是真是假，传播他人私密聊天记录的行为已经涉嫌侵犯隐私权。如果聊天记录系伪造，制作者和传播者还可能承担诽谤的刑事责任。</p>
<p>王一博工作室于今日凌晨紧急发布声明，表示已委托律师收集证据，将对造谣者和恶意传播者追究法律责任。声明同时呼吁粉丝保持理性，不要参与网络骂战。</p>
<p>本平台将持续关注此事的法律进展。</p>`,
    category: "明星爆料",
    categorySlug: "mingxing-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20male%20celebrity%20in%20dark%20stylish%20outfit%20with%20dramatic%20shadow%20lighting%2C%20cinematic%20portrait%20photography%2C%20moody%20atmosphere%2C%20high%20contrast%20black%20and%20red%20tones%2C%20mysterious%20vibe%2C%20editorial%20style%2C%20night%20scene&width=800&height=600&seq=article-03&orientation=landscape",
    author: "娱乐圈纪检委",
    date: "2026-07-05",
    views: 2150000,
    comments: 8923,
    tags: ["王一博", "私聊记录", "爆料", "粉丝大战", "律师函"],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: "mou-yin-yue-jie-mu-nei-ding-guanjun",
    title: "某音乐综艺节目被曝内定冠军，选手录音曝光，节目组：正在调查",
    excerpt: "一档热播音乐综艺节目被爆出存在严重的内定问题。一段据称是节目导演与某选手经纪人的通话录音在网上流传，内容直指冠军已被提前内定，引发观众强烈不满。",
    content: `<p>一档热播音乐综艺节目被爆出存在严重的内定问题。一段据称是节目导演与某选手经纪人的通话录音在网上流传，内容直指冠军已被提前内定。</p>
<p>这段时长约三分钟的录音中，一个被指认为节目导演的男声明确表示"冠军已经定了，你们只能争第二"，并暗示某赞助商品牌指定了最终获胜者。录音中的另一个声音据称是某选手的经纪人，语气中充满了无奈和愤怒。</p>
<p>录音曝光后，立即在社交媒体上引发轩然大波。大量观众涌入节目官方账号评论区表达愤怒："看了三个月原来是看剧本""退我会员费""综艺节目的公信力何在"。</p>
<p>节目组随后发布声明，称正在对录音来源和内容进行调查，并表示"节目始终坚持公平公正的原则，所有比赛结果均由专业评审和观众投票共同决定"。但这一声明并未平息观众的质疑。</p>
<p>业内人士指出，综艺节目内定现象并非个案。在商业利益的驱动下，部分节目组为了确保"爆款"效果，会提前安排剧本和人设。"观众以为自己看的是真人秀，其实看的是'真人设'。"</p>
<p>目前，相关监管部门已关注到此事，表示将介入调查。</p>`,
    category: "娱乐圈内幕",
    categorySlug: "yulequan-neimu",
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20with%20spotlight%20and%20microphone%2C%20dramatic%20dark%20atmosphere%2C%20cinematic%20lighting%2C%20empty%20stage%20with%20judges%20table%20in%20shadow%2C%20moody%20and%20suspenseful%2C%20night%20aesthetic%2C%20high%20contrast&width=800&height=600&seq=article-04&orientation=landscape",
    author: "综艺真相帝",
    date: "2026-07-04",
    views: 756000,
    comments: 3287,
    tags: ["音乐综艺", "内定", "录音曝光", "节目组", "黑幕"],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    slug: "mou-ding-liu-nv-xing-bei-zhua-pai-yue-hui",
    title: "某顶流女星深夜密会被拍，男方身份曝光竟是已婚富豪，网友炸了",
    excerpt: "知名狗仔团队拍到某顶流女星深夜与一神秘男子密会的画面。经过网友深扒，该男子身份浮出水面——竟是一位已婚富豪。此事迅速登上热搜榜首，女星团队正在紧急公关。",
    content: `<p>知名狗仔团队拍到某顶流女星深夜与一神秘男子密会的画面。经过网友深扒，该男子身份浮出水面——竟是一位已婚富豪。</p>
<p>据报道，狗仔团队跟踪拍摄了整整一周，最终捕捉到了决定性画面。视频显示，该女星深夜独自驾车前往某高档小区，一名男子在车库等候，两人随后一同进入电梯。约四小时后，女星独自离开。</p>
<p>视频发布后，网友们迅速展开"人肉搜索"，很快锁定了该男子的身份——某知名地产集团的副总裁，且已有家室。这一发现让整个事件的性质发生了根本性变化。</p>
<p>"知三当三？""这也太毁三观了吧""心疼原配"——相关话题迅速登上热搜榜首，阅读量在两小时内突破2亿。女星的粉丝群体出现了明显的分裂，一部分选择相信"只是朋友关系"，另一部分则表示"脱粉"。</p>
<p>该女星的经纪团队目前正在紧急公关，据传已联系多家媒体试图压下报道。但鉴于事件的热度，收效甚微。</p>
<p>本平台友情提醒：吃瓜需理性，请勿对当事人进行网络暴力。</p>`,
    category: "明星爆料",
    categorySlug: "mingxing-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20female%20celebrity%20walking%20alone%20at%20night%20in%20luxury%20apartment%20complex%2C%20paparazzi%20style%20photography%2C%20dark%20moody%20atmosphere%2C%20grainy%20night%20shot%2C%20high%20contrast%20shadows%2C%20cinematic%20noir%20aesthetic%2C%20mysterious%20vibe&width=800&height=600&seq=article-05&orientation=landscape",
    author: "狗仔阿伟",
    date: "2026-07-03",
    views: 3200000,
    comments: 12500,
    tags: ["顶流女星", "密会", "已婚富豪", "塌房", "狗仔"],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    slug: "zhu-bo-wu-yong-ti-yu-pin-pai-zhi-liang-men",
    title: "某知名运动品牌被曝代工厂偷工减料，博主打假视频播放破千万",
    excerpt: "一位测评博主发布视频，实锤某知名运动品牌代工厂存在偷工减料行为。视频中对比了该品牌官方宣传材质与实际产品的巨大差异，引发消费者集体维权。",
    content: `<p>一位测评博主发布视频，实锤某知名运动品牌代工厂存在偷工减料行为。视频中对比了该品牌官方宣传材质与实际产品的巨大差异。</p>
<p>该博主在视频中展示了详细的对比测试过程。他将该品牌官方旗舰店购买的产品与代工厂流出样品进行了逐一对比，从面料、缝线、鞋底材质等多个维度揭示了明显的质量问题。</p>
<p>"官方宣传用的是进口高弹面料，实际检测发现是普通涤纶。成本差了至少五倍。"博主在视频中说道。他还展示了第三方检测机构的检测报告，为视频提供了有力的证据支撑。</p>
<p>视频发布后迅速走红，播放量在48小时内突破千万。大量购买过该品牌产品的消费者纷纷在评论区晒出自己的"翻车"经历，控诉产品质量问题。部分消费者已经自发组织起来，准备发起集体维权诉讼。</p>
<p>该品牌官方尚未就此事做出正面回应，但据内部人士透露，品牌方已经紧急召回了涉事批次产品，并开始对代工厂进行全面审查。</p>
<p>有律师表示，如果品牌方在宣传中存在虚假或引人误解的内容，消费者有权要求"退一赔三"。</p>`,
    category: "网红塌房",
    categorySlug: "wanghong-tafang",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20brand%20factory%20production%20line%20in%20dark%20industrial%20setting%2C%20dramatic%20cinematic%20lighting%2C%20shadowy%20atmosphere%2C%20quality%20inspection%20scene%2C%20high%20contrast%2C%20documentary%20style%20photography%2C%20night%20industrial%20aesthetic&width=800&height=600&seq=article-06&orientation=landscape",
    author: "打假先锋",
    date: "2026-07-02",
    views: 1100000,
    comments: 5678,
    tags: ["运动品牌", "代工厂", "偷工减料", "打假", "维权"],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    slug: "mou-you-xi-zhu-bo-kai-gua-bei-shi-chui",
    title: "某游戏主播被实锤开挂，直播画面与游戏数据不一致，平台已封禁",
    excerpt: "一位拥有百万粉丝的游戏主播被技术流网友实锤使用外挂。通过逐帧分析直播画面与游戏后台数据，网友发现了多处无法解释的不一致之处。目前该主播直播间已被平台永久封禁。",
    content: `<p>一位拥有百万粉丝的游戏主播被技术流网友实锤使用外挂。通过逐帧分析直播画面与游戏后台数据，网友发现了多处无法解释的不一致之处。</p>
<p>事情的起因是该主播在一次直播中展现出了超乎寻常的游戏水平，连续做出多个职业选手都难以完成的极限操作。起初粉丝们还在欢呼"神操作"，但很快就有专业人士提出了质疑。</p>
<p>一位自称是游戏开发者的网友发布了长达40分钟的技术分析视频。视频中通过逐帧慢放和后台数据比对，指出了至少五处"人类不可能完成"的操作。其中最致命的是，主播的操作响应速度远超游戏引擎的极限，这意味着他使用的工具绕过了游戏的正常检测机制。</p>
<p>证据链完整公布后，舆论迅速反转。大量粉丝表示"被欺骗了"，纷纷取关。该主播的粉丝数在一夜之间从120万跌至不足40万。</p>
<p>游戏直播平台迅速反应，在确认证据后对该主播直播间进行了永久封禁处理。平台官方公告称："我们对于任何形式的作弊行为零容忍。"</p>
<p>该事件再次引发了人们对游戏直播行业诚信问题的讨论。有业内人士呼吁建立更严格的直播监管机制，保护观众和平台的利益。</p>`,
    category: "电竞吃瓜",
    categorySlug: "dianjing-chigua",
    imageUrl: "https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20RGB%20lighting%20in%20dark%20room%2C%20dramatic%20atmosphere%2C%20gaming%20monitor%20displaying%20game%2C%20cyberpunk%20aesthetic%2C%20neon%20accents%2C%20high%20contrast%2C%20cinematic%20photography%2C%20moody%20lighting&width=800&height=600&seq=article-07&orientation=landscape",
    author: "电竞观察员",
    date: "2026-07-01",
    views: 890000,
    comments: 4100,
    tags: ["游戏主播", "开挂", "实锤", "封禁", "电竞"],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    slug: "mou-zong-yi-jia-bing-qing-jie-bei-zhi-jia-ju",
    title: "某综艺嘉宾被指情节造假，素人嘉宾身份遭起底，前科曝光",
    excerpt: "一档热播婚恋综艺节目中的素人嘉宾被网友扒出身份造假。该嘉宾自称「普通白领」，却被发现实际上是某MCN机构的签约网红，且有过多次综艺参演经历。",
    content: `<p>一档热播婚恋综艺节目中的素人嘉宾被网友扒出身份造假。该嘉宾自称「普通白领」，却被发现实际上是某MCN机构的签约网红。</p>
<p>据网友深扒，这位在节目中声称自己是"金融行业普通白领"的女嘉宾，实际上是一名拥有20万粉丝的美妆博主。更令人震惊的是，她此前曾以不同身份参加过至少三档综艺节目，每次都扮演不同的"素人"角色。</p>
<p>网友还挖出了她在某MCN机构的签约记录，以及多张与其他签约网红的合照。这些证据清晰地表明，"素人"身份从头到尾都是一场精心设计的表演。</p>
<p>节目组在舆论发酵后发布声明，称"在嘉宾筛选环节存在疏漏"，并表示将加强审核。但这一解释并未平息观众的愤怒。大量观众质疑节目组是"知假用假"，利用"素人"的噱头来制造话题。</p>
<p>业内人士透露，不少综艺节目的"素人嘉宾"实际上都是"伪素人"。他们可能是MCN机构的小网红、十八线艺人、或者是有表演经验的路人演员。"真正的素人镜头感太差，节目效果不好，所以节目组更倾向于用'伪素人'。"</p>
<p>此事已经引发了广电部门的关注，或将推动综艺节目嘉宾审查制度的改革。</p>`,
    category: "综艺八卦",
    categorySlug: "zongyi-bagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Reality%20TV%20show%20set%20with%20dramatic%20lighting%20and%20cameras%2C%20behind%20the%20scenes%20atmosphere%2C%20cinematic%20photography%2C%20dark%20studio%20with%20spotlights%2C%20moody%20vibe%2C%20high%20contrast%20shadows%2C%20entertainment%20industry%20aesthetic&width=800&height=600&seq=article-08&orientation=landscape",
    author: "综艺打假办",
    date: "2026-06-30",
    views: 670000,
    comments: 2890,
    tags: ["综艺", "嘉宾造假", "素人", "MCN", "剧本"],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    slug: "mou-yin-yue-jie-bei-zhi-chao-xi",
    title: "某音乐节被指抄袭海外知名音乐节舞美设计，对比图惊人相似",
    excerpt: "国内某大型音乐节被指抄袭海外知名音乐节的舞台设计。网友晒出的对比图显示，两个音乐节的主舞台从结构到灯光布局几乎一模一样，仅有颜色上的微小差异。",
    content: `<p>国内某大型音乐节被指抄袭海外知名音乐节的舞台设计。网友晒出的对比图显示，两个音乐节的主舞台从结构到灯光布局几乎一模一样。</p>
<p>这场争议始于一位参加过多个国际音乐节的乐迷。他在社交平台发布了一组对比图，将国内某音乐节的主舞台与海外某知名音乐节去年的舞台进行了并排对比。相似度之高令人咋舌——从舞台的整体架构、屏幕布局，到灯光的排列方式、甚至装饰元素的摆放位置，都展现出惊人的一致性。</p>
<p>"好的设计值得学习，但这不是学习，这是复制粘贴。"该乐迷在帖子中写道。</p>
<p>帖子迅速引发了广泛讨论。设计行业人士指出，舞台设计属于建筑作品范畴，受著作权法保护。如果抄袭行为属实，涉事方可能面临法律诉讼。</p>
<p>该音乐节的主办方至今未做出回应。但据知情人士透露，主办方内部正在紧急修改后续场次的舞台设计方案，以避免进一步的法律风险。</p>
<p>这一事件让人们对国内音乐节的原创能力产生了质疑。有业内人士感慨："中国音乐节市场发展很快，但创意能力却没有跟上。"</p>`,
    category: "娱乐圈内幕",
    categorySlug: "yulequan-neimu",
    imageUrl: "https://readdy.ai/api/search-image?query=Music%20festival%20stage%20with%20dramatic%20lighting%20and%20laser%20effects%2C%20night%20outdoor%20concert%2C%20cinematic%20wide%20shot%2C%20dark%20atmosphere%20with%20colorful%20lights%2C%20epic%20scale%2C%20high%20contrast%2C%20moody%20festival%20aesthetic&width=800&height=600&seq=article-09&orientation=landscape",
    author: "音乐圈内人",
    date: "2026-06-29",
    views: 543000,
    comments: 2340,
    tags: ["音乐节", "抄袭", "舞台设计", "版权", "原创"],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    slug: "mou-zhi-bo-jian-shou-jia-yi-jia",
    title: "某直播间售假被市场监管部门查处，涉案金额超千万，主播已被控制",
    excerpt: "某知名带货直播间因涉嫌销售假冒奢侈品被市场监管部门突击查处。现场查获大量假冒名牌包袋、手表等商品，涉案金额初步估计超过千万元。涉事主播已被警方控制。",
    content: `<p>某知名带货直播间因涉嫌销售假冒奢侈品被市场监管部门突击查处。现场查获大量假冒名牌包袋、手表等商品，涉案金额初步估计超过千万元。</p>
<p>据执法部门通报，此次行动是在接到大量消费者投诉后展开的。执法人员在该直播间位于义乌的仓库中查获了数千件假冒国际奢侈品牌商品，包括仿制的名牌包袋、手表、首饰等。这些假货的仿真度极高，普通消费者很难辨别真伪。</p>
<p>"他们甚至在假货上贴了防伪标签，手段非常专业。"一位执法人员表示。</p>
<p>该直播间拥有超过200万粉丝，主打"源头好货""工厂直供"的概念，以远低于市场价的价格销售所谓的"正品奢侈品"。许多消费者被低价和主播的煽动性话术所吸引，纷纷下单购买。</p>
<p>目前，涉事主播已被警方控制，案件正在进一步调查中。法律界人士表示，销售假冒注册商标商品罪最高可判处七年有期徒刑并处罚金。</p>
<p>此事件再次敲响了直播带货行业的警钟。消费者协会提醒广大消费者：天上不会掉馅饼，价格异常低廉的"奢侈品"极有可能是假货。</p>`,
    category: "直播翻车",
    categorySlug: "zhibo-fanche",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20goods%20warehouse%20with%20police%20raid%20scene%2C%20dramatic%20night%20atmosphere%2C%20cinematic%20documentary%20style%2C%20dark%20industrial%20setting%20with%20flashlights%2C%20high%20contrast%2C%20moody%20crime%20scene%20aesthetic%2C%20investigative%20journalism%20vibe&width=800&height=600&seq=article-10&orientation=landscape",
    author: "打假一线",
    date: "2026-06-28",
    views: 1560000,
    comments: 7800,
    tags: ["直播间", "售假", "查处", "奢侈品", "假货"],
    isHot: false,
    isNew: false,
  },
];

export const hotTags = [
  "丁真塌房", "李佳琦", "王一博", "综艺内定", "顶流密会",
  "直播翻车", "游戏开挂", "带货假货", "网红造假", "娱乐圈黑幕",
  "明星爆料", "塌房现场", "狗仔实锤", "粉丝大战", "品牌打假",
];

export const testimonials = [
  {
    id: 1,
    name: "资深吃瓜人",
    username: "@chigua_lao",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20young%20man%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%2C%20professional%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-01&orientation=squarish",
    comment: "吃瓜黑料在线真的是我见过更新最快的八卦平台了！每次有大瓜都是第一时间推送，比微博热搜还快。上次丁真那件事，我是全网第一批知道的人，就因为在吃瓜黑料在线蹲到了第一手消息。",
  },
  {
    id: 2,
    name: "娱乐圈观察者",
    username: "@yule_insider",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20woman%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%20professional%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-02&orientation=squarish",
    comment: "内容很全面，从网红到明星、从综艺到电竞，什么瓜都有。而且爆料的深度比一般娱乐号强多了，很多内幕信息其他平台根本看不到。已经推荐给身边所有爱吃瓜的朋友了！",
  },
  {
    id: 3,
    name: "吃瓜小能手",
    username: "@melon_lover",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20young%20person%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-03&orientation=squarish",
    comment: "每天上班摸鱼就在这上面吃瓜哈哈哈哈。内容太劲爆了，有时候看得我直接在工位上笑出声。不过信息量确实大，每天都要花至少一小时才能把当天的瓜吃完。",
  },
  {
    id: 4,
    name: "八卦研究员",
    username: "@gossip_research",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20woman%20with%20glasses%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-04&orientation=squarish",
    comment: "作为一个专业的八卦爱好者，我对信息来源的要求很高。吃瓜黑料在线的爆料都是有实锤才发，不像某些平台随便编个聊天记录就当新闻。这种严谨的态度很难得。",
  },
  {
    id: 5,
    name: "深夜吃瓜人",
    username: "@midnight_melon",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20young%20man%20with%20hoodie%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-05&orientation=squarish",
    comment: "每天晚上睡前必须刷一遍吃瓜黑料在线，不然感觉一天都不完整。好几次看瓜看到凌晨三点，第二天顶着熊猫眼去上班。但是这瓜真的太香了，根本停不下来！",
  },
  {
    id: 6,
    name: "理性吃瓜群众",
    username: "@rational_fan",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20Chinese%20woman%20with%20casual%20look%2C%20dark%20background%2C%20editorial%20style%2C%20minimalist%20headshot%2C%20moody%20lighting%2C%20high%20contrast&width=80&height=80&seq=avatar-06&orientation=squarish",
    comment: "虽然叫'吃瓜黑料'，但这个平台的态度其实挺客观的。不会刻意带节奏，也不会为了流量故意炒作。每条爆料都会注明来源和可信度，让我们能理性吃瓜。这点真的很赞。",
  },
];

export const faqs = [
  {
    question: "吃瓜黑料在线的爆料信息可信吗？",
    answer: "我们坚持「有实锤才发」的原则。每一条爆料都会经过多方交叉验证，标注信息来源和可信度等级。对于未经证实的传闻，我们会明确标注「待核实」标签，让用户理性判断。",
  },
  {
    question: "如何第一时间收到最新爆料推送？",
    answer: "您可以通过关注我们的官方社交媒体账号、下载官方APP（即将上线）或收藏本站并开启浏览器通知来获取最新爆料推送。我们承诺：重大爆料发生后5分钟内推送。",
  },
  {
    question: "被爆料的内容可以要求删除吗？",
    answer: "如果爆料内容存在事实错误，我们会在核实后立即更正或撤稿。但如果爆料内容属实且涉及公众利益，我们将依法保留报道权利。任何删稿请求请通过官方邮箱提交书面材料和证据。",
  },
  {
    question: "吃瓜黑料在线有APP吗？",
    answer: "我们的APP正在紧锣密鼓地开发中，预计将于近期上线各大应用商店。届时将提供更流畅的阅读体验、更及时的推送通知和独家爆料内容。敬请期待！",
  },
  {
    question: "如何投稿爆料？",
    answer: "欢迎知情人士向我们投稿爆料！请将相关资料发送至我们的官方邮箱，我们承诺对投稿人信息绝对保密。对于重大独家爆料，我们将提供丰厚稿酬。",
  },
  {
    question: "网站的更新频率是怎样的？",
    answer: "我们的编辑团队7×24小时不间断追踪网络热点事件。重大事件发生后，通常在5-15分钟内即可发布第一手报道。日常更新频率约为每小时2-3条内容，确保您不错过任何大瓜。",
  },
];

export const siteInfo = {
  name: "吃瓜黑料在线",
  tagline: "网红塌房现场 · 黑料实时更新",
  description: "吃瓜黑料在线首页聚合站，实时更新51吃瓜在线观看、黑料在线、网红塌房现场、明星黑料爆料等内容，提供吃瓜黑料在线官网入口、app下载指引，每日不间断追踪网络热点事件。",
  url: "https://www.chiguaheiliaozx.com",
  email: "tips@chiguaheiliaozx.com",
  weibo: "@吃瓜黑料在线",
  wechat: "chiguaheiliaozx",
  founded: "2024",
  stats: {
    dailyVisitors: "500万+",
    totalArticles: "10,000+",
    updateFrequency: "24小时不间断",
    categories: "6大",
    teamSize: "50+",
  },
};